if( !customElements.get('range-slider') ) {
  customElements.define('range-slider',
    class RangeSlider extends HTMLElement {
      constructor() {
        super();

        this.minSlider = document.getElementById('Mobile-Filter-Price-GTE');
        this.maxSlider = document.getElementById('Mobile-Filter-Price-LTE');
        this.minValueBox = document.getElementById('min-value');
        this.maxValueBox = document.getElementById('max-value');
        this.maxSliderMax = parseInt(this.maxSlider.max);

        this.minSlider.addEventListener('input', this.handleMinSlider.bind(this));
        this.maxSlider.addEventListener('input', this.handleMaxSlider.bind(this));

        this.minSlider.dispatchEvent(new Event('input'));
        this.maxSlider.dispatchEvent(new Event('input'));
      }

      handleMinSlider() {
        const minValue = parseInt(this.minSlider.value);
        const maxValue = parseInt(this.maxSlider.value);

        if (minValue > maxValue - 10) {
            this.minSlider.value = maxValue - 10;
        }

        this.minValueBox.textContent = this.minSlider.value;
        this.updateBackground();
      }

      handleMaxSlider() {
        const minValue = parseInt(this.minSlider.value);
        const maxValue = parseInt(this.maxSlider.value);

        if (maxValue < minValue + 10) {
            this.maxSlider.value = minValue + 10;
        }

        this.maxValueBox.textContent = this.maxSlider.value;
        this.updateBackground();
      }

      updateBackground() {
        const minValue = parseInt(this.minSlider.value);
        const maxValue = parseInt(this.maxSlider.value);
        const minPercent = (minValue / this.maxSliderMax) * 100;
        const maxPercent = (maxValue / this.maxSliderMax) * 100;

        this.minSlider.style.background = `linear-gradient(to right, #ddd 0%, #ddd ${minPercent}%, #000 ${minPercent}%, #000 100%)`;
        this.maxSlider.style.background = `linear-gradient(to right, #ddd 0%, #ddd ${minPercent}%, #000 ${minPercent}%, #000 ${maxPercent}%, #ddd ${maxPercent}%, #ddd 100%)`;
      }
    }
  )
}